import ProductCategorySelect from "@components/product-category/components/ProductCategorySelect";
import { CONDITION_RULE_CHECK } from "@constants/cart-rule";
import AppContext from "@helpers/context";
import { Icon, ObjectUtils, Select } from "d-react-components";
import { map } from "lodash";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const CONDITION_TYPE = ObjectUtils.mapObjectToArray(CONDITION_RULE_CHECK);

const CategoryCondition = ({
  payload,
  conditionList,
  setChangeCondition,
  indexText,
  handleDeleteCondition,
}: any) => {
  const { cartRuleConditionDisabled } = useContext(AppContext);

  const { rule, id, label, condition } = payload;
  const { t } = useTranslation();

  //*****************************************CONTROL_UI************************************************** */

  const handleChangeRuleCondition = (changedPayload: any) => {
    const cloneList = map(conditionList, (item) => {
      if (item.id === changedPayload.id) {
        return changedPayload;
      }
      return item;
    });
    setChangeCondition(cloneList);
  };

  const onChangeCategory = async (categoryList: any) => {
    const clonePayload = { ...payload, [condition]: categoryList };
    const cloneList = map(conditionList, (item) => {
      if (item.id === payload.id) {
        return clonePayload;
      }
      return item;
    });
    setChangeCondition(cloneList);
  };

  //*****************************************RENDER_UI************************************************** */

  return (
    <div className="mt-2 border border-primary">
      <div className="flex-row-between-center bg-primary px-2">
        <div className="flex-row align-items-center">
          <text className="font-weight-bold text-white">
            {`${t("condition")} ${indexText}: `}
          </text>
          <div className="ml-1 text-white">{t("category")}</div>
          <Select
            className="ml-2 cart-rule__condition-select"
            dataSource={CONDITION_TYPE}
            getLabel={(option) => t(option.label)}
            variant="standard"
            disabled={cartRuleConditionDisabled}
            value={payload?.rule}
            onChange={(value) => {
              handleChangeRuleCondition({
                ...payload,
                rule: value,
              });
            }}
          />
        </div>
        {!cartRuleConditionDisabled && (
          <Icon
            name="remove_circle"
            color="white"
            onClick={handleDeleteCondition}
          />
        )}
      </div>
      <div className="p-3">
        <ProductCategorySelect
          label=""
          className="mt-3"
          multiple
          value={payload.category}
          onChange={(values) => onChangeCategory(values)}
          disabled={cartRuleConditionDisabled}
        />
      </div>
    </div>
  );
};

export default CategoryCondition;
